<template>
  <div class="container-fluid"  >
    <div class="row mt-3"   >
      <div class="col-12 col-sm-12 mb-4 col-md-4 col-lg-4 " v-if="block.data.cols.length==3" v-for="(block_3_col,index_block_3_col) in block.data.cols" :key="'block_3_col_index'+index_block_3_col">

          <EditorJsColumnRender :align_style="align_style" :block="block_3_col" :key="'block_children_3'+index_block_3_col"/>


      </div>
      <div class="col-12 col-sm-6 mb-4 col-md-6 col-lg-6" v-if="block.data.cols.length==2" v-for="(block_2_col,index_block_2_col) in block.data.cols" :key="'block_2_col_index'+index_block_2_col">
        <EditorJsColumnRender :align_style="align_style" :block="block_2_col" :key="'block_children_2'+index_block_2_col"/>
       </div>
    </div>



  </div>
</template>

<script>

import EditorJsColumnRender from "./EditorJsColumnRender";
export default {
  name: "EditorjsColumns",
  components: {
    'EditorJsColumnRender': EditorJsColumnRender,
  },

  props: ["block",'align_style'],
  data(){
    return {

    }
  },
  beforeCreate: function () {
    this.$options.components.EditorJsColumnRender =EditorJsColumnRender;
  },
  methods: {},
  mounted(){
    var app=this;



  }
}
</script>

<style scoped>

</style>